export enum NotInsuredReason {
  EXPIRED_LAST_30_DAYS = 'expired_last_30_days',
  DID_NOT_OWN_VEHICLE = 'did_not_own_vehicle',
  DRIVING_WITH_NO_INSURANCE = 'driving_with_no_insurance',
  DID_NOT_DRIVE_6_MONTHS = 'did_not_drive_6_months',
  OVERSEAS_MILITARY = 'overseas_military',
  OTHER = 'other',
}

export enum AutoInsuredLength {
  LessThanSixMonths = 'LessThanSixMonths',
  SixToTwelveMonths = 'SixToTwelveMonths',
  OneToThreeYears = 'OneToThreeYears',
  ThreeToFiveYears = 'ThreeToFiveYears',
  MoreThanFiveYears = 'MoreThanFiveYears',
}
